import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
// Import other required components and libraries
import {
    Col,
    Row,
    Alert,
    Button,
    ButtonToolbar,
    Modal,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Card,
    CardBody
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingIcon from "mdi-react/LoadingIcon";
import ProductsTable from "../../../Home/components/ProductsWidget/components/ProductsTable";
import Panel from "../../../../shared/components/Panel";
import Log from "../../../../Models/Logs/Log";

const ProductAddLog = ({ dispatch, rtl }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [log, setLog] = useState(null);
    const [logType, setLogType] = useState('ALL'); // State variable for log type
    const [numOfLines, setNumOfLines] = useState('50'); // State variable for number of lines
    const [showDate, setShowDate] = useState(false); // Added state variable for show date checkbox
    const logRef = useRef(null);
    const lm = new Log();

    useEffect(() => {
        fetchData();

        const intervalId = setInterval(fetchData, 5000);
        return () => clearInterval(intervalId);
    }, [logType, numOfLines, showDate]); // useEffect now depends on logType, numOfLines, and showDate

    useEffect(() => {
        if (isLoaded && logRef.current) {
            logRef.current.scrollTop = logRef.current.scrollHeight;
        }
    }, [log, isLoaded]);

    const fetchData = () => {
        const formdata = new FormData();
        formdata.append('logName', 'productAddLog');
        formdata.append('numberOfLines', numOfLines);
        formdata.append('showDate', showDate); // Add showDate to form data

        if (logType !== 'ALL') {
            formdata.append('type', logType);
        }

        return lm.getLog(formdata).then(async response => {
            if (response.data.status === 'failed') {
                alert('failed');
                return false;
            }

            setLog(response.data.data);
            setIsLoaded(true);
            return true;
        });
    };

    return (
        <Panel xl={12} lg={12} md={12} title={'Product Add Log'} refreshFunction={fetchData}>
            {!isLoaded &&
            <div className="panel__refresh"><LoadingIcon /></div>
            }
            {isLoaded &&
            <>
                <Row>
                    <Col xs={4}>
                        <select value={logType} onChange={(e) => setLogType(e.target.value)}>
                            <option value="ALL">All</option>
                            <option value="NOTICE">Notice</option>
                            <option value="ERROR">Error</option>
                            <option value="WARNING">Warning</option>
                            <option value="EXCEPTION">Exception</option>
                        </select>
                    </Col>
                    <Col xs={4}>
                        <select value={numOfLines} onChange={(e) => setNumOfLines(e.target.value)}>
                            <option value="50">50 Lines</option>
                            <option value="100">100 Lines</option>
                            <option value="200">200 Lines</option>
                            <option value="300">300 Lines</option>
                        </select>
                    </Col>
                    <Col xs={4}>
                        <label className="checkbox-btn" htmlFor="show-date">
                            <input
                                className=""
                                checked={showDate}
                                type="checkbox"
                                id="show-date"
                                onChange={(e) => setShowDate(e.target.checked)}
                            />
                            <span className="checkbox-btn__label">Show Date</span>
                        </label>
                    </Col>
                </Row>
                <div className="scrolling-wrapper-flexbox">
                    <pre className="logViewer p-2" ref={logRef}>{log}</pre>
                </div>
            </>
            }
        </Panel>
    );
};

export default connect(state => ({
    rtl: state.rtl
}))(ProductAddLog);